// src/services/paymentService.js
import authService from './authService';
import { API_BASE_URL } from './config';

const API_BASE = API_BASE_URL;

// Fetch with automatic token refresh on 401
const authFetch = async (url, options = {}) => {
  const makeHeaders = () => ({
    ...authService.getAuthHeaders(),
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...options.headers,
  });

  let res = await fetch(url, { ...options, headers: makeHeaders() });

  if (res.status === 401) {
    try {
      await authService.refreshAccessToken();
      res = await fetch(url, { ...options, headers: makeHeaders() });
    } catch {
      throw new Error('Session expired. Please log in again.');
    }
  }

  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Request failed');
  return json;
};

// Initiate M-Pesa STK push for a tier subscription
export const initiatePayment = async ({ tier, phone }) => {
  const json = await authFetch(`${API_BASE}/payments/initiate`, {
    method: 'POST',
    body: JSON.stringify({ tier, phone }),
  });
  return json; // { checkoutRequestId, message }
};

// Poll payment status
export const getPaymentStatus = async (checkoutRequestId) => {
  return authFetch(`${API_BASE}/payments/status/${checkoutRequestId}`);
};

// Assign stations for basic tier (locked once confirmed)
export const setupBasicStations = async (deviceIds) => {
  const json = await authFetch(`${API_BASE}/auth/setup-basic`, {
    method: 'POST',
    body: JSON.stringify({ deviceIds }),
  });
  return json.user;
};

// Get user's payment history
export const getMyPayments = async () => {
  const json = await authFetch(`${API_BASE}/payments/my-payments`);
  return json.payments;
};
